import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import CustomInputNumber from "@/components/desktop/form/input/input-number/CustomInputNumber";
import CustomInputSwitch from "@/components/desktop/form/input/input-switch/CustomInputSwitch";
import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";

import useUserStore from "@/stores/useUserStore";

import styles from "./io-form.module.scss";

const IOFields = ({ formData, application, oaOptions = [], onUpdateField }) => {
	const { user } = useUserStore();

	return (
		<div className={styles.section}>
			<div className={styles.fieldsGrid}>
				<CustomInputSelect
					label="Ordenes de Aplicación"
					name="oas"
					options={oaOptions}
					value={formData.oas || []}
					onChange={(val) => onUpdateField("oas", val)}
					placeholder="Seleccionar OA..."
					isClearable={true}
					isMulti={true}
					col={12}
				/>

				<CustomInputText
					label="Fecha de Peso"
					name="date_weight"
					type="datetime-local"
					value={formData.date_weight || ""}
					onChange={(value) => onUpdateField("date_weight", value)}
					col={6}
				/>

				{!!user?.superuser && (
					<>
						<CustomInputNumber
							label="Peso Balanza"
							name="weight"
							value={formData.weight || 0}
							onChange={(value) => onUpdateField("weight", value)}
							decimals={2}
							col={6}
						/>
						<CustomInputNumber
							label="Peso Envase (gr)"
							name="product_container_weight"
							value={application.product_container_weight || 0}
							onChange={(value) => onUpdateField("product_container_weight", value)}
							decimals={2}
							col={6}
						/>

						<CustomInputNumber
							label="Densidad"
							name="product_density"
							value={application.product_density || 0}
							onChange={(value) => onUpdateField("product_density", value)}
							decimals={2}
							col={6}
						/>
					</>
				)}

				{!!application?.entry && (
					<>
						<CustomInputSwitch
							label="Envase Vacío"
							value={formData.empty_container || false}
							onChange={(value) => onUpdateField("empty_container", value)}
							optionLeft="No"
							optionRight="Sí"
							col={3}
						/>

						<CustomInputSwitch
							label="No Utilizado"
							value={formData.not_used || false}
							onChange={(value) => onUpdateField("not_used", value)}
							optionLeft="No"
							optionRight="Sí"
							col={3}
						/>
					</>
				)}
			</div>
		</div>
	);
};

export default IOFields;
